import React from 'react';
import { full_design } from '../../static/full_design';
import { ChannelsTable } from '../Edu/ChannelsTable';
import { AdminMenu } from './AdminMenu';

export function AdminChannels(props) {

  return (
    <>
      <div className="b b--admin">
        <AdminMenu
          active="channels"
        />
        <div
          className='admin_content'>
          <ChannelsTable design={full_design} />
        </div>
      </div>
    </>
  )
}
